var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-qr',{attrs:{"text":_vm.href + _vm.tempId}}),_c('div',[_vm._v(_vm._s(_vm.href + _vm.tempId))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }